<template>
    <van-popup :value="showPop" class="van-popup-radius-10 width80p" @click-overlay="clickCancel">
        <div class="delete-record-item-note text-center">
            <p>{{notify1}}</p>
            <p v-if="notify2" class="red">{{notify2}}</p>
        </div>
        <div class="van-hairline--top van-dialog__footer van-dialog__footer--buttons">
            <button class="van-button van-button--default van-button--large van-dialog__cancel" @click="clickCancel">
                <div class="van-button__content"><span class="van-button__text">取消</span></div>
            </button>
            <button class="van-button van-button--default van-button--large van-dialog__confirm" @click="clickConfirm">
                <div class="van-button__content"><span class="van-button__text">确定</span></div>
            </button>
        </div>
    </van-popup>
</template>

<script>
export default {
    name: 'DeleteRecordItemPop',
    data() {
        return {
            showPop: false,
            notify1: '',
            notify2: '',
            confirmFunc: undefined
        }
    },
    mounted() {
        this.$bus.on('showDeleteRecordItemPop', this.showPopUp)
    },
    destroyed() {
        this.$bus.off('showDeleteRecordItemPop', this.showPopUp)
    },
    methods: {
        clickCancel() {
            this.showPop = false;
        },
        clickConfirm() {
            this.showPop = false;
            if(this.confirmFunc) {
                this.confirmFunc();
            }
        },
        showPopUp(params) {
            this.showPop = true;
            this.notify1 = params.text1;
            this.notify2 = params.text2;
            this.confirmFunc = params.cb;
        }
    }
}
</script>